import Utils from "./Utils";
import * as THREE from "three";
import GlobalColorSingleton from "./GlobalColor";
export default class RemoteTexture {
  constructor(url, max = 8) {
    this.url = url;
    // this.folder = folder;
    this.max = max;
  }

  load() {
    return new Promise(async (resolve, reject) => {
      const data = await Utils.loadJSON(this.url);

      console.log("data", data);
      // get first key from data to extract the color palette
      const firstKey = Object.keys(data)[0];
      this._data = data[firstKey].textures;
      const url = this._data[Math.floor(Math.random() * this._data.length)];
      await GlobalColorSingleton.getColorFromImage(`getImage/${url}`);

      this.KEYWORD = firstKey.toLowerCase();
      this.ASSET_ID = data[firstKey].hero; // data[firstKey].id;
      // this.HERO = data[firstKey].hero;
      this.LINK = data[firstKey].link;
      this.INDEX = data[firstKey].index;

      const promise_array = [];
      const loader = new THREE.TextureLoader();
      const VARIATION_DICT = {};

      const lettersCount = {};
      for (const image_url of data[firstKey].textures) {
        //  HANDLE BAD IMAGES HERE FROM DATA....
        // COUNTING letterVariation

        /**
         * lets assum all images are valid
         */
        console.log(image_url);
        // console.log(image_url.split("_").at(-2));
        const tmp_url = image_url.split("_");
        // const letter = image_url.split("_").at(-2).toLowerCase();
        const letter = tmp_url[tmp_url.length - 2].toLowerCase();
        if (lettersCount[letter]) {
          lettersCount[letter]++;
        } else {
          lettersCount[letter] = 1;
        }
        if (lettersCount[letter] <= this.max) {
          promise_array.push(loader.load(`getImage/${image_url}`));
        }
      }

      const values = await Promise.all(promise_array).then((values) => {
        let w = 0;
        const dict = {};
        let total = 0;
        const texture_name = data[firstKey].textures[0].split("_");
        // let prev_letter = data[firstKey].textures[0]
        //   .split("_")
        //   .at(-2)
        //   .toLowerCase();
        let prev_letter = texture_name[texture_name.length - 2].toLowerCase();
        for (const image_url of data[firstKey].textures) {
          //  HANDLE BAD IMAGES HERE FROM DATA....
          // COUNTING letterVariation

          /**
           * lets assume all images are valid
           */
          const tmp = image_url.split("_");

          // const letter = image_url.split("_").at(-2).toLowerCase();
          const letter = tmp[tmp.length - 2].toLowerCase();

          if (!dict[letter] || dict[letter].length < this.max) {
            if (letter != prev_letter) {
              total += lettersCount[prev_letter];
              prev_letter = letter;
            }
            // console.log(w);
            if (dict.hasOwnProperty(letter) == false) {
              dict[letter] = [values[w]];
            } else {
              dict[letter].push(values[w]);
            }

            w++;
          }
        }

        dict["default"] = [this.createDefaultTexture()];
        dict["image"] = this.getRandomImage();
        console.log(dict);
        return dict;
      });
      resolve(values);
      // for (const key in data) {
      //   let letterVariation = 0;
      //   let letter_count = 0;
      //   for (let i = 0; i < 8; i++) {
      //     if (letter_count < this.max) {
      //       if (!data[key].missing.includes(i)) {
      //         // const image_url = `${this.folder}/${data[key].id}_${i}.png.jpg`;
      //         const image_url = `${data[key].id}_${i}.png.jpg`;

      //         letterVariation++;
      //         promise_array.push(loader.load(image_url));
      //         letter_count++;
      //       }
      //     }
      //   }
      //   VARIATION_DICT[key] = letterVariation;
      // }

      // const values = await Promise.all(promise_array).then((values) => {
      //   let w = 0;
      //   const dict = {};
      //   let total = 0;
      //   for (const key in data) {
      //     for (let w = 0; w < VARIATION_DICT[key]; w++) {
      //       if (w == 0) {
      //         dict[key] = [values[w + total]];
      //       } else {
      //         dict[key].push(values[w + total]);
      //       }
      //     }
      //     total += VARIATION_DICT[key];
      //   }
      //   dict["default"] = [this.createDefaultTexture()];
      //   return dict;
      // });
      // resolve(values);
    });
  }

  createDefaultTexture() {
    // create a texture with default DEFAULT_COLOR
    let canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    let context = canvas.getContext("2d", { willReadFrequently: true });
    context.fillStyle = "#" + GlobalColorSingleton.tmp_color.toString(16);
    context.fillRect(0, 0, 1, 1);
    let defaultTexture = new THREE.CanvasTexture(canvas);
    defaultTexture._colorValue =
      "#" + GlobalColorSingleton.tmp_color.toString(16);
    return defaultTexture;
  }

  getRandomImage() {
    const url = this._data[Math.floor(Math.random() * this._data.length)];
    return `getImage/${url}`;
  }
}
